import { useEffect, useState } from "react";

/** The width at and below which a screen is laid out for a phone; the same breakpoint as the stylesheets' `max-width: 40rem`. */
const NarrowQuery = "(max-width: 40rem)";

/**
 * Whether the screen is phone-sized, for a page that shows something different there rather than only restyling it. No
 * `matchMedia` (a test, an old browser) means not narrow.
 */
export function useNarrow(): boolean {
  const [narrow, setNarrow] = useState(() => typeof window.matchMedia === "function" && window.matchMedia(NarrowQuery).matches);

  useEffect(() => {
    if (typeof window.matchMedia !== "function") {
      return undefined;
    }

    const list = window.matchMedia(NarrowQuery);
    const onChange = (): void => setNarrow(list.matches);
    onChange();
    list.addEventListener("change", onChange);
    return () => list.removeEventListener("change", onChange);
  }, []);

  return narrow;
}
